import useAiAccess from './useAiAccess'
import useWhoToAsk from './useWhoToAsk'
import { refuse } from '../utils/permissionReason'

/**
 * May the caller dictate (POST /transcribe)? Since security audit C23 the
 * server holds dictation to the agent-session rule: the caller's level must
 * reach agent_sessions and their team's budget must allow an interactive
 * feature (checkVoiceSpend in goapi metering.go). Every surface that offers
 * the mic, including the panes open below agent level (the Help pane, the
 * insights drawers, Help me write this, the Theme AI agent, the Tables pane),
 * draws it disabled with this reason rather than letting the person record
 * and then fail. With the customer's switch off /me reports level 4 and no
 * budget, so nothing changes. Until /me answers, the mic is left alone.
 *
 * customer is the customer NAME.
 */
export interface DictationAccess {
  allowed: boolean
  /** Why not, and who to ask, for the mic's DisabledReason. Undefined when allowed. */
  reason: string | undefined
}

export const DICTATION_REFUSAL = "You can't use voice input without agent access."

export function useDictationAccess(customer: string | null | undefined): DictationAccess {
  const aiAccess = useAiAccess(customer ?? undefined)
  const who = useWhoToAsk(customer ?? undefined)
  if (!aiAccess.levelAllows('agent_sessions')) {
    return { allowed: false, reason: refuse(DICTATION_REFUSAL, who).reason }
  }
  if (!aiAccess.can('agent_sessions')) {
    return { allowed: false, reason: aiAccess.refusalFor('agent_sessions') }
  }
  return { allowed: true, reason: undefined }
}

export default useDictationAccess
